









































































import Vue from "vue";

// Import Models
import { Ingredient } from "../../models/formulationStep.model";

// Import Components
import Divider from "@miele/component-library-vue/src/components/elements/Divider.vue";

export default Vue.extend({
  name: "RecipeSteps",
  props: {
    step: {
      type: Object,
      required: true,
    },
    stepsLength: {
      type: Number,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
    appliance: {
      type: String,
      required: false,
    },
  },
  components: {
    Divider,
  },
  methods: {
    displayIngredient(ingredient: any) {
      let groceryName = "";
      const ingredientName = ingredient?.grocery?.name;
      const ingredientQuantity = ingredient?.quantity;

      if (ingredientQuantity === 1 && ingredientName.one !== null) {
        groceryName = ingredientName.one;
      } else if (ingredientQuantity > 1 && ingredientName.two !== null) {
        groceryName = ingredientName.two;
      } else {
        groceryName = ingredientName.other;
      }

      const checkDecimal = (quantity: any) => {
        if (quantity % 1 != 0) {
          return parseFloat(quantity).toFixed(2);
        } else {
          return quantity;
        }
      };

      return `<b>${
        ingredientQuantity ? checkDecimal(ingredientQuantity) : ""
      } ${
        ingredient.grocery.unit ? ingredient.grocery.unit?.one : ""
      }</b> ${groceryName} ${
        ingredient.grocery.comment ? "(" + ingredient.grocery.comment + ")" : ""
      }`;
    },
    displaySettings(setting: any) {
      const settingList = [];
      const deviceType = `<b>${this.appliance}</b> (${setting.title})`;
      const settingText = setting.text;
      if (deviceType && setting.title) settingList.push(deviceType);
      if (deviceType && setting.title) settingList.push(...settingText);
      let settingsHTML = ``;
      settingList.forEach((item) => (settingsHTML += item + "<br />"));
      return settingsHTML;
    },
  },
});
